import { GoogleMap, InfoWindow, Marker } from "@react-google-maps/api";
import { useEffect, useState } from "react";
import { MapProvider } from "./map-provider/MapProvider";

type LocationDetails = {
  city: string;
  country: string;
};

export const defaultMapContainerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "15px 15px",
};

// const center = { lat: 11.527316, lng: 104.959075 };

export default function GoogleMapEdit({
  latitude,
  longitude,
  onValueChange,
  getLocationDetail,
}: {
  latitude: number;
  longitude: number;
  onValueChange: (coords: { lat: number; lng: number }) => void;
  getLocationDetail?: (locationDetail: {
    city: string;
    country: string;
  }) => void | undefined;
}) {
  const [center, setCenter] = useState<any>({
    lat: Number(latitude),
    lng: Number(longitude),
  });
  const [open, setOpen] = useState(false);

  const [markerPosition, setMarkerPosition] = useState<{
    lat: number;
    lng: number;
  } | null>(null);

  const [locationDetails, setLocationDetails] = useState<LocationDetails>({
    city: "",
    country: "",
  });

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        setCenter({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    } else {
      console.log("Geolocation is not available in your browser.");
    }
  }, []);

  const getLocationName = async (event: {
    latLng: { lat: () => number; lng: () => number };
  }) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setMarkerPosition({ lat, lng });
    // Geocode the clicked position
    const geocoder = new window.google.maps.Geocoder();
    const response = await geocoder.geocode({ location: { lat, lng } });

    if (response.results && response.results[0]) {
      const addressComponents = response.results[0].address_components;
      // Extract city and country
      const city = addressComponents.find((comp) =>
        comp.types.includes("administrative_area_level_1")
      )?.long_name;

      const country = addressComponents.find((comp) =>
        comp.types.includes("country")
      )?.long_name;

      if (city && country) {
        setLocationDetails({ city, country });
        getLocationDetail?.({
          city,
          country,
        });
      } else {
        setLocationDetails({
          city: city || "",
          country: country || "",
        });
      }
    }
  };

  const onMapClick = (e: any) => {
    setCenter({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
    onValueChange({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
    getLocationName(e);
  };

  if (center.lat === 0 && center.lng === 0) {
    setCenter({ lat: Number(11.556441), lng: Number(104.92818) });
  }

  return (
    <MapProvider>
      <GoogleMap
        center={center}
        zoom={15}
        mapContainerStyle={defaultMapContainerStyle}
        onClick={onMapClick}
      >
        <Marker onClick={() => setOpen(true)} position={center} />
        {open && (
          <InfoWindow position={center} onCloseClick={() => setOpen(false)}>
            {locationDetails && (
              <div>
                <p>
                  {!locationDetails.city && !locationDetails.country
                    ? "The location is not set."
                    : "My location"}
                </p>
              </div>
            )}
          </InfoWindow>
        )}
      </GoogleMap>
    </MapProvider>
  );
}
